import { template1Styling } from "@made-people/blueprint-image-and-text/blueprint";

template1Styling.main.override({
  slots: {
    wrapper: "text-body-sm lg:text-body-md",
    imageWrapper: "overflow-hidden flex justify-center items-center",
    image: "object-cover object-center flex overflow-hidden rounded-md",
    content: "flex flex-col items-start justify-center",
    text: "",
    link: "",
  },
  variants: {
    layout: {
      vertical: {
        wrapper: "flex flex-col gap-6 md:gap-6 lg:gap-8 align-center",
        imageWrapper: "w-full",
        content: "w-full gap-4 md:gap-4 lg:gap-2",
      },
      verticalReverse: {
        wrapper: "flex flex-col-reverse gap-6 md:gap-6 lg:gap-8",
        imageWrapper: "w-full",
        content: "w-full gap-4 md:gap-4 lg:gap-2",
      },
      horizontal: {
        wrapper: "w-full flex flex-row gap-3 md:gap-4 lg:gap-5",
        imageWrapper: "md:w-1/2",
        content: "md:w-1/2 gap-4 md:gap-6 lg:gap-8",
      },
      horizontalReverse: {
        wrapper: "w-full flex flex-row-reverse gap-3 md:gap-4 lg:gap-5",
        imageWrapper: "md:w-1/2",
        content: "md:w-1/2 gap-4 md:gap-6 lg:gap-8",
      },
    },
    contentAlignment: {
      left: {
        content: "items-start text-left",
      },
      center: {
        content: "items-center text-center",
      },
    },
  },
  defaultVariants: {
    layout: {
      initial: "vertical",
      lg: "horizontal",
    },
    contentAlignment: "left",
  },
});
